import { inject } from '@angular/core'
import { finalize } from 'rxjs'
import { AppStore } from '../app.store'
import { environment } from 'src/environments/environment'
import { LoadingRequestCounterService } from './loading-request-counter.service'
import { HttpInterceptorFn } from '@angular/common/http'

export const loadingInterceptorFn: HttpInterceptorFn = (req, next) => {
    const counter = inject(LoadingRequestCounterService)
    const appStore = inject(AppStore)

    const url = (req.url || '').toLowerCase()
    const base = (environment.baseUrl || '').toLowerCase()

    // skip requests that don't target your API
    if (!url.startsWith(base)) {
        return next(req)
    }

    // remove skipGlobalLoading param if present
    if (req.params.has('skipGlobalLoading')) {
        const params = req.params.delete('skipGlobalLoading')
        const cloned = req.clone({ params })
        // don't track this request
        // console.debug('[loadingInterceptor] skipGlobalLoading for', req.urlWithParams)
        return next(cloned)
    }

    // --- 🧠 Skip SignalR / long-lived connections ---
    if (url.includes('/negotiate') || url.includes('/hub') || url.includes('/signalr')) {
        // console.debug('[loadingInterceptor] Skipping long-lived request:', req.url)
        return next(req)
    }

    // remove if no auth header
    if (!req.headers.has('Authorization')) {
        // console.debug('[loadingInterceptor] No auth header, skipping request:', req.url)
        return next(req)
    }

    // increment and set loading if needed
    counter.increment()
    // keep AppStore in sync for compatibility
    if (counter.count > 0) {
        appStore.setLoadingState(true)
    }

    return next(req).pipe(
        finalize(() => {
            counter.decrement()
            // keep AppStore in sync
            if (counter.count === 0) {
                appStore.setLoadingState(false)
            }
        })
    )
}
